import {
    GatsbyImage,
    IGatsbyImageData,
    StaticImage,
} from 'gatsby-plugin-image';

import React from 'react';

type GatsbyImageWrapperProps = {
    className?: string;
    imageIndex?: number;
    imgStyle?: any;
    fields?: Queries.ProductsJsonFields;
    gatsbyImages?: IGatsbyImageData[];
};

export default function GatsbyImageWrapper(props: GatsbyImageWrapperProps) {
    const { fields, className, imgStyle, gatsbyImages } = props;
    let gatsbyImageData;

    const imageIndex: number = props.imageIndex ? props.imageIndex : 0;
    if (!fields?.imageUrls) {
        gatsbyImageData = gatsbyImages?.[imageIndex];

        if (fields && !gatsbyImageData) {
            gatsbyImageData =
                fields?.images?.[imageIndex]?.childImageSharp?.gatsbyImageData;
        }
    }

    return (
        <>
            {gatsbyImageData ? (
                <GatsbyImage
                    className={className ? className : ''}
                    image={gatsbyImageData}
                    imgStyle={imgStyle}
                    alt=''
                />
            ) : (
                <>
                    {fields?.imageUrls?.[imageIndex] ? (
                        <img
                            className={`gatsby-image-wrapper ${
                                className ? className : ''
                            }`}
                            src={fields?.imageUrls[imageIndex] as string}
                            style={imgStyle}
                            alt=''
                        />
                    ) : (
                        <StaticImage
                            className={className ? className : ''}
                            src='../images/product-image-placeholder.jpg'
                            imgStyle={{ objectFit: 'contain' }}
                            alt=''
                        />
                    )}
                </>
            )}
        </>
    );
}
